<template>
  <div
    class="grid grid-cols-12 gap-8 md:gap-10 bg-custom-darkblue text-white p-5 md:p-20 "
  >
    <div class="col-span-12">
      <h1 class="text-4xl md:text-5xl ">Webb.</h1>
    </div>
    <div class="col-span-12 md:col-span-6">
      <p class="text-md md:text-2xl ">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. A dolores
        exercitationem voluptatum, consequatur ab vero quasi quae maiores
        laudantium optio enim in numquam tempore nostrum!
      </p>
    </div>
    <div class="col-span-6 md:col-span-3">
      <ul class="capitalize text-md md:text-2xl font-semibold">
        <li class="mb-5 hover:text-custom-purple"><a href="#">about us</a></li>
        <li class="mb-5 hover:text-custom-purple">
          <a href="#">newsletter</a>
        </li>
        <li class="mb-5 hover:text-custom-purple">
          <a href="#">privacy policy</a>
        </li>
      </ul>
    </div>
    <div class="col-span-6 md:col-span-3">
      <ul class="capitalize text-md md:text-2xl font-semibold">
        <li class="mb-5 hover:text-custom-purple">
          <a href="#">webb community</a>
        </li>
        <li class="mb-5 hover:text-custom-purple"><a href="#">bookings</a></li>
        <li class="mb-5 hover:text-custom-purple"><a href="#">calender</a></li>
      </ul>
    </div>
    <div class="col-span-12  md:col-span-9 ">
      <p class="text-md md:text-2xl text-center md:text-left">
        Copyright © All Rights Reserved Webb. Estate Community Hall
      </p>
    </div>
    <div class="col-span-12 md:col-span-3 text-3xl text-center md:text-left ">
      <a href="#">
        <i class="ri-facebook-circle-fill mx-4 hover:text-custom-purple "></i>
      </a>
      <a href="#">
        <i class="ri-twitter-fill mx-4 hover:text-custom-purple"></i>
      </a>
      <a href="#">
        <i class="ri-instagram-fill mx-4 hover:text-custom-purple"></i>
      </a>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style></style>
